module.exports = __webpack_public_path__ + "static/media/item_17_5_comp.3c0631ab.png";